
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo/demographic",
      function () {
        return require("private-next-pages/demo/demographic.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo/demographic"])
      });
    }
  